<template>
  <div id="reset-pasword">
    <div class="form-container">
      <form>
        <h3>Reset Password</h3>
        <div v-if="!showSuccess">
          <form @submit.prevent>
            <label for="email">Email</label>
            <input
              name="email"
              v-model.trim="email"
              type="email"
              placeholder="you@email.com"
            />
          </form>
          <p v-if="errorCode" class="error">{{ errorText }}</p>
          <button @click="resetPassword()" class="button valid" type="button">
            Reset
          </button>
        </div>
        <p v-else>Success! Check your email for a reset link.</p>
      </form>
    </div>
  </div>
</template>

<script>
import { auth } from '../../firebase';

export default {
  name: 'PasswordReset',
  props: {
    defaultEmail: { type: String },
  },
  data() {
    return {
      email: '',
      showSuccess: false,
      errorCode: null,
    };
  },
  created() {
    this.email = this.defaultEmail || '';
  },
  methods: {
    async resetPassword() {
      try {
        await auth.sendPasswordResetEmail(this.email);
        this.$toasted.show('Mot de passe envoyé !');
        this.$emit('close');
      } catch (err) {
        this.errorCode = err.code;
      }
    },
  },
  computed: {
    errorText() {
      return this.$t(`login.errors.${this.errorCode}`);
    },
  },
};
</script>

<style lang="scss" scoped src="./PasswordReset.scss"></style>
